import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const baseUrl = process.env.REACT_APP_API_BASE_URL


const campaignApi = createApi({
  reducerPath: "campaignApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (Headers: Headers, api) => {
      const token = localStorage.getItem("token");
      token && Headers.append("Authorization", "Bearer " + token);
    },
  }),
  tagTypes: ["Campaign"],
  endpoints: (builder) => ({
    getCampaigns: builder.query({
      query: () => ({
        url: "Campaign",
        method: "GET",
      }),
      providesTags: ["Campaign"],
    }),
    getCampaignById: builder.query({
      query: (campaignId) => ({
        url: `Campaign/${campaignId}`,
      }),
      providesTags: ["Campaign"],
    }),
    createCampaign: builder.mutation({
      query: (formData) => ({
        url: "Campaign",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Campaign"],
    }),
    updateCampaign: builder.mutation({
      query: ({ data, id }) => ({
        url: `Campaign/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Campaign"],
    }),
    updateCampaignStatus: builder.mutation({
      query: ({ id, isActive }) => ({
        url: `Campaign/${id}/status`,
        method: "PATCH",
        body: { id, isActive },
      }),
      invalidatesTags: ["Campaign"],
    }),
    deleteCampaign: builder.mutation({
      query: ({ id }) => ({
        url: `Campaign/${id}`,
        method: "Delete",
      }),
      invalidatesTags: ["Campaign"],
    }),
  }),
});

export const {
  useGetCampaignsQuery,
  useGetCampaignByIdQuery,
  useCreateCampaignMutation,
  useUpdateCampaignMutation,
  useUpdateCampaignStatusMutation,
  useDeleteCampaignMutation,
} = campaignApi;
export default campaignApi;
